import { FormItemsGroup } from '@billy/design-system'

import { useIsInvoiceEditorElementRestricted } from '../../../../../../../../../../../../hooks/useIsInvoiceEditorElementRestricted'
import { CommonInvoiceLineFieldProps } from '../../../../types/commonInvoiceLineFieldProps'
import { InvoiceDescription } from './elements/InvoiceDescription'

type InvoiceDescriptionLineFieldsProps = CommonInvoiceLineFieldProps

export const InvoiceDescriptionLineFields = ({ lineIndex }: InvoiceDescriptionLineFieldsProps) => {
  const isDisabled = useIsInvoiceEditorElementRestricted('description', 'disabled')

  return (
    <FormItemsGroup itemsInRow={1}>
      <InvoiceDescription disabled={isDisabled} lineIndex={lineIndex} />
    </FormItemsGroup>
  )
}
